"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var types_1 = require("../../types");
var utils_1 = require("../../utils");
var MonthPicker = /** @class */ (function (_super) {
    __extends(MonthPicker, _super);
    function MonthPicker(props) {
        var _this = _super.call(this, props) || this;
        _this._focusItemRef = function (r) {
            if (r) {
                r.focus();
            }
        };
        _this._handleChange = function (month, year) {
            _this.props.onChange && _this.props.onChange(month, year);
        };
        _this._handleKeyDown = function (e, rowIdx, cellIdx) {
            var _a = _this.props, monthRows = _a.monthRows, monthYear = _a.monthYear, onNext = _a.onNext, onPrev = _a.onPrev, onCloseCalendar = _a.onCloseCalendar;
            var _b = _this.state, focusedCell = _b.focusedCell, focusedRow = _b.focusedRow;
            var keyCode = e.keyCode;
            if (keyCode === types_1.KeyCode.Enter || keyCode === types_1.KeyCode.Space) {
                _this._handleChange(monthRows[rowIdx][cellIdx], monthYear);
            }
            else if (keyCode === types_1.KeyCode.Tab &&
                !e.shiftKey &&
                e.target.className.indexOf('DayPicker-Month-Item') >= 0) {
                onCloseCalendar();
            }
            else if (keyCode === types_1.KeyCode.ArrowUp ||
                keyCode === types_1.KeyCode.ArrowDown ||
                keyCode === types_1.KeyCode.ArrowLeft ||
                keyCode === types_1.KeyCode.ArrowRight) {
                var newValues = utils_1.handleKeyboardNav(e, focusedRow, focusedCell, monthRows);
                _this.setState({
                    focusedCell: newValues.cell,
                    focusedRow: newValues.row
                });
                if (newValues.changePage) {
                    if (newValues.pageChangeDir === 'next') {
                        onNext();
                    }
                    else if (newValues.pageChangeDir === 'prev') {
                        onPrev();
                    }
                }
            }
        };
        _this.state = {
            focusedCell: 0,
            focusedRow: 0
        };
        return _this;
    }
    MonthPicker.prototype.componentDidMount = function () {
        var _a = this.props, month = _a.month, monthRows = _a.monthRows;
        var focus = {
            cell: 0,
            row: 0
        };
        monthRows.forEach(function (row, rowIdx) {
            row.forEach(function (cell, cellIdx) {
                if (month === cell) {
                    focus.cell = cellIdx;
                    focus.row = rowIdx;
                }
            });
        });
        this.setState({
            focusedCell: focus.cell,
            focusedRow: focus.row
        });
    };
    MonthPicker.prototype.render = function () {
        var _this = this;
        var _a = this.props, classNames = _a.classNames, initialDate = _a.initialDate, monthNames = _a.monthNames, monthNamesLong = _a.monthNamesLong, monthRows = _a.monthRows, monthYear = _a.monthYear;
        if (!monthNames.length || !monthNamesLong.length)
            return null;
        return (React.createElement("div", { className: "custom-selector month-selector" },
            React.createElement("div", { className: "DayPicker-Months", role: "grid" },
                React.createElement("div", { className: classNames.body, role: "rowgroup" }, monthRows.map(function (monthRow, rowIdx) {
                    return (React.createElement("div", { className: "DayPicker-Month-Row", role: "row", key: "month-row-" + rowIdx }, monthRow.map(function (monthItem, cellIdx) {
                        var monthNameShort = monthNames[monthItem];
                        var monthNameLong = monthNamesLong[monthItem];
                        var ref;
                        var itemProps = {
                            className: 'DayPicker-Month-Item',
                            ref: ref,
                            role: 'gridcell',
                            tabIndex: -1,
                            key: "month-item-" + monthNameShort,
                            'aria-label': monthNameLong + " " + monthYear,
                            'aria-selected': false,
                            onClick: function (e) {
                                e.preventDefault();
                                _this._handleChange(monthItem, monthYear);
                            },
                            onKeyDown: function (e) {
                                _this._handleKeyDown(e, rowIdx, cellIdx);
                            }
                        };
                        if (monthItem === initialDate.getMonth() && monthYear === initialDate.getFullYear()) {
                            itemProps.className = itemProps.className + " p-bg-primary50 p-br-md p-t-light selected";
                            itemProps['aria-selected'] = true;
                        }
                        if (rowIdx === _this.state.focusedRow && cellIdx === _this.state.focusedCell) {
                            itemProps.ref = function (r) { return _this._focusItemRef(r); };
                            itemProps.tabIndex = 0;
                        }
                        return React.createElement("div", __assign({}, itemProps), monthNameShort);
                    })));
                })))));
    };
    return MonthPicker;
}(React.Component));
exports.default = MonthPicker;
//# sourceMappingURL=MonthPicker.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/date-picker/build/control/components/MonthPicker.js
// module id = 303
// module chunks = 0 1